/**
 * Turn CSV content into a file download.
 *
 * Uses an object URL instead of a `data:` URI so that large reports
 * (e.g. a full year of workflows) are not truncated by the browser's
 * data URI size limit.
 */
const downloadCsv = (csvContent, fileName) => {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Firefox and Safari fetch the blob asynchronously, so revoking in the same
  // tick can cancel the download before it has started.
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

export default downloadCsv;
